import registerPharmacyFlow from './RegisterPharmacy';

export const routes: any[] = [];
const FLOWS = {
	registerPharmacy: {
		exact: true,
		path: '/register-pharmacy/',
		component: registerPharmacyFlow,
	},
};

routes.push(FLOWS.registerPharmacy);

export default FLOWS;
export const RegisterPharmacyFlow = registerPharmacyFlow;
